import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchProjectdossierGlobalsLists,
  initialState,
} from '../services/fetchProjectdossierGlobalsLists'

export { useProjectdossierGlobalsLists }

const useProjectdossierGlobalsLists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchProjectdossierGlobalsLists,
    queryKey: ['valuelists-projectdossier', 'globals'],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
